// extracted by css-extract-rspack-plugin
export default {"expandingAreaWrapper":"_ea633ddf"};